<div class="row">

  <div class="col-md-12">
    <div mat-dialog-content>


      


      <form [formGroup]="_searchForm" ng-submit="sendForm()">
        <div class="row">

          <div class="form-group  col-md-4">

            <mat-form-field class="full-width">
              <intelli-selector  (change)="changeFire($event)"  placeholder="status" [options]="purchaseStatus" formControlName="status"></intelli-selector>
            </mat-form-field>

          </div>

          <div class="form-group col-md-4">
            <mat-form-field class="full-width">
              <intelli-data-selector matInput placeholder="Empresa" [options]="options" [controllerName]="'Companies'" formControlName="companyId"> </intelli-data-selector>
            </mat-form-field>
          </div>

          <div class="form-group col-md-4">
            <mat-form-field class="full-width">
              <intelli-data-selector matInput placeholder="Produto"  [options]="options" [controllerName]="'Products2'" formControlName="productId"> </intelli-data-selector>
            </mat-form-field>
          </div>

          
          <div class="form-group col-md-4">
              <mat-form-field class="full-width">
                <intelli-yesorno matInput placeholder="Mostrar somente pedidos incompletos ?"   formControlName="onlyIncomplete"> </intelli-yesorno>
              </mat-form-field>
            </div>

        </div>

        <div class="row">

          <div class="form-group  col-md-12">
            <mat-form-field class="search-full-width">
<!-- cdkFocusInitial [(ngModel)]="data.searchText"  (keydown.enter)="closeDialog()-->
              <input  matInput placeholder="Digite as palavras para busca"  formControlName="searchText" >


            </mat-form-field>
          </div>
        </div>
      </form>

    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-1" style="text-align: right" >
    <div mat-dialog-actions>
      <button mat-icon-button [mat-dialog-close]="_searchForm.value">
        <mat-icon>youtube_searched_for</mat-icon>
      </button>

    </div>
  </div>

</div>